import { render, staticRenderFns } from "./FormIcon.vue?vue&type=template&id=196ce906&scoped=true"
import script from "./FormIcon.vue?vue&type=script&lang=js"
export * from "./FormIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ce906",
  null
  
)

export default component.exports